const form = document.getElementById("form") as HTMLFormElement;

const submitButton = document.getElementById("submit-button");

if (submitButton !== null) {
  submitButton.addEventListener("click", (e) => {
    onHcaptchaClick(e).catch((err) => {
      console.error(err);
    });
  });
}

function onHcaptchaCompleted(): void {
  form.submit();
}

async function onHcaptchaClick(e: Event): Promise<void> {
  e.preventDefault();

  if (!form.checkValidity()) {
    form.reportValidity();
    return;
  }

  submitButton!.dataset.fetching = "";
  await hcaptcha.execute();
}

function undoHcaptchaFetching(): void {
  delete submitButton!.dataset.fetching;
}

window.onHcaptchaClick = onHcaptchaClick;
window.onHcaptchaCompleted = onHcaptchaCompleted;
window.undoHcaptchaFetching = undoHcaptchaFetching;
